export var FUNCTION_NAMES = {
    socialStoryGenerator: "generateSocialStory",
    articulationWordListGenerator: "generateArticulationWordList",
    vocabularyWordListGenerator: "generateVocabularyList",
};
